<template>
  <div></div>
</template>

<script>
export default {
  name: "Home",

  components: {
    //
  },

  mounted() {
    var main_container = document.getElementById("app");
    main_container.classList.add("home");

    this.$bRoot.setDrawer(true);
    this.$bRoot.errors = null;
  }
};
</script>
